module.exports = __webpack_public_path__ + "img/img_txt_internet_jalnan.ec1ea22f.svg";